import React from 'react';
import { queries } from '../../../graphql/graphql';
import PaginatedAdminList from '../../../components/containers/PaginatedAdminList';

const ListUsers: React.FC = () => {
  return (
    <PaginatedAdminList
      prefix="user"
      query={queries.users.USERS}
      inline={true}
      editable={true}
      canCreate={true}
      adminView={true}
      defaultPageSize={20}
    />
  );
};

export default ListUsers;
